import { defineComponent, reactive } from "vue";
import { useRouter } from "vue-router";
export default defineComponent({
  name: "rankOfficial",
  props: {
    officialList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  setup: function setup() {
    var router = useRouter(); //官方榜背景色

    var offiBgc = reactive(["#f3e0e7", "#e1ebea", "#e2e6ef", "#f2e0e0"]);
    var offiColor = reactive(["#ed3079", "#26998b", "#3a71c1", "#e22626"]);
    /* 点击图片跳转排行歌单 */

    var rankClick = function rankClick(id) {
      router.push("/main/playlistdetail/".concat(id));
    };

    return {
      offiBgc: offiBgc,
      offiColor: offiColor,
      rankClick: rankClick
    };
  },
  components: {}
});